"use client"
import React from "react"
import { usePathname } from "next/navigation"
import BaseHeader from "@/app/components/base/BaseHeader"
import { TRAVEL_LANDING_PRESETS } from "@/app/components/travelComparator/landing/travelLandingPresets"
import { isTravelFunnelEnabled } from "@/app/components/travelComparator/travelFunnelFlag"

interface Props {
    comparatorStyle?: boolean
    compact?: boolean
    containerClassName?: string
}

// Guide landings share the guide layout, so their compact mobile header is chosen by path
const COMPACT_HEADER_PATHS = new Set([
    "/guide/prevoyance",
    ...(isTravelFunnelEnabled() ? Object.keys(TRAVEL_LANDING_PRESETS) : []),
])

export default function Header({comparatorStyle = false, compact = false, containerClassName}: Props = {}) {
    const pathname = usePathname()
    const isCompact = compact || COMPACT_HEADER_PATHS.has(pathname)

    if (comparatorStyle) {
        return <BaseHeader comparatorStyle compact={isCompact} containerClassName={containerClassName} />
    }

    return (
        <BaseHeader
            compact={isCompact}
            start={["Logo"]}
            center={["Nav"]}
            end={["Actu"]}
        />
    )
}
